module.exports = __webpack_public_path__ + "static/media/cny-popup-bg-tr.b3985e41.png";